import { createSlice } from "@reduxjs/toolkit";
import { createThunkFromApi } from "store/utils";
import investmentApi from "./investmentApi";

export const getInvestmentPortfolioCurrentlyList = createThunkFromApi(
  "investment/getInvestmentPortfolioCurrentlyList",
  investmentApi.getInvestmentPortfolioCurrentlyList
);

export const getInvestmentFixedCurrentlyList = createThunkFromApi(
  "investment/getInvestmentFixedCurrentlyList",
  investmentApi.getInvestmentFixedCurrentlyList
);

export const checkInvestmentRulesConfirmation = createThunkFromApi(
  "investment/checkInvestmentRulesConfirmation",
  investmentApi.checkInvestmentRulesConfirmation
);

export const getInvestmentBuyList = createThunkFromApi(
  "investment/getInvestmentBuyList",
  investmentApi.getInvestmentBuyList
);

export const getInvestmentPortfolioCancel = createThunkFromApi(
  "investment/getInvestmentPortfolioCancel",
  investmentApi.getInvestmentPortfolioCancel
);

export const getInvestmentFixedCancel = createThunkFromApi(
  "investment/getInvestmentFixedCancel",
  investmentApi.getInvestmentFixedCancel
);

export const investmentPortfolioCancel = createThunkFromApi(
  "investment/investmentPortfolioCancel",
  investmentApi.investmentPortfolioCancel 
);

export const investmentFixedCancel = createThunkFromApi(
  "investment/investmentFixedCancel",
  investmentApi.investmentFixedCancel
);

export const getInvestmentFixedClose = createThunkFromApi(
  "investment/getInvestmentFixedClose",
  investmentApi.getInvestmentFixedClose
);

export const investmentPortfolioClose = createThunkFromApi(
  "investment/investmentPortfolioClose",
  investmentApi.investmentPortfolioClose 
);

export const investmentFixedClose = createThunkFromApi(
  "investment/investmentFixedClose",
  investmentApi.investmentFixedClose
);

export const investmentPortfolioBuy = createThunkFromApi(
  "investment/investmentPortfolioBuy",
  investmentApi.investmentPortfolioBuy
);

export const getInvestmentPortfolioClose = createThunkFromApi(
  "investment/getInvestmentPortfolioClose",
  investmentApi.getInvestmentPortfolioClose
);

export const getInvestmentPortfolioBuyAmountMax = createThunkFromApi(
  "investment/getInvestmentPortfolioBuyAmountMax",
  investmentApi.getInvestmentPortfolioBuyAmountMax
);

export const getInvestmentPortfolioHistoryForm = createThunkFromApi(
  "investment/getInvestmentPortfolioHistoryForm",
  investmentApi.getInvestmentPortfolioHistoryForm
);

export const getInvestmentPortfolioHistoryList = createThunkFromApi(
  "investment/getInvestmentPortfolioHistoryList",
  investmentApi.getInvestmentPortfolioHistoryList
);

export const getInvestmentPortfolioRequestHistoryForm = createThunkFromApi(
  "investment/getInvestmentPortfolioRequestHistoryForm",
  investmentApi.getInvestmentPortfolioRequestHistoryForm
);

export const getInvestmentPortfolioRequestHistoryList = createThunkFromApi(
  "investment/getInvestmentPortfolioRequestHistoryList",
  investmentApi.getInvestmentPortfolioRequestHistoryList
);

export const getPortfolioChartList = createThunkFromApi(
  "investment/getPortfolioChartList",
  investmentApi.getPortfolioChartList
);

export const getInvestmentPortfolioCurrentlyInfo = createThunkFromApi(
  "investment/getInvestmentPortfolioCurrentlyInfo",
  investmentApi.getInvestmentPortfolioCurrentlyInfo
);

export const getInvestmentFixedCurrentlyInfo = createThunkFromApi(
  "investment/getInvestmentFixedCurrentlyInfo",
  investmentApi.getInvestmentFixedCurrentlyInfo
);

export const getUnitTradeChartList = createThunkFromApi(
  "investment/getUnitTradeChartList",
  investmentApi.getUnitTradeChartList
);

export const getPortfolioChartPartialList = createThunkFromApi(
  "investment/getPortfolioChartPartialList",
  investmentApi.getPortfolioChartPartialList
);

const initialState = {
  investmentPortfolioList: [],
  investmentFixedList: [],
  investmentPortfolioBuyAmountMax: [],
  investmentBuyList: [],
  investmentHistoryForm: [],
  investmentHistoryList: [],
  investmentPortfolioInfo: {},
  investmentFixedInfo: {},
  unitTradeChartList: [],
  portfolioChartPartialList: []
};

export const investmentSlice = createSlice({
  name: "investment",
  initialState,

  extraReducers: {
    [getInvestmentPortfolioCurrentlyList.fulfilled]: (state, { payload }) => {
      state.investmentPortfolioList = payload.data;
    },

    [getInvestmentFixedCurrentlyList.fulfilled]: (state, { payload }) => {
      const sortedData = payload?.data?.data?.sort((a, b) => {
        return new Date(b.dateStamp) - new Date(a.dateStamp); // نزولی (جدیدتر اول)
      });
    
      state.investmentFixedList = {
        ...payload.data,
        data: sortedData,
      };
    },

    [getInvestmentBuyList.fulfilled]: (state, { payload }) => {
      state.investmentBuyList = payload?.data;
    },

    [getInvestmentPortfolioBuyAmountMax.fulfilled]: (state, { payload }) => {
      state.investmentPortfolioBuyAmountMax = payload?.data;
    },

    [getInvestmentPortfolioHistoryForm.fulfilled]: (state, { payload }) => {
      state.investmentHistoryForm = payload?.data;
    },

    [getInvestmentPortfolioHistoryList.fulfilled]: (state, { payload }) => {
      state.investmentHistoryList = payload?.data;
    },

    [getInvestmentPortfolioRequestHistoryForm.fulfilled]: (state, { payload }) => {
      state.investmentHistoryForm = payload?.data;
    },

    [getInvestmentPortfolioRequestHistoryList.fulfilled]: (state, { payload }) => {
      state.investmentHistoryList = payload?.data;
    },

    [getInvestmentPortfolioCurrentlyInfo.fulfilled]: (state, { payload }) => {
      state.investmentPortfolioInfo = payload?.data;
    },

    [getInvestmentFixedCurrentlyInfo.fulfilled]: (state, { payload }) => {
      state.investmentFixedInfo = payload?.data;
    },

    [getUnitTradeChartList.fulfilled]: (state, { payload }) => {
      state.unitTradeChartList = payload?.data;
    },

    [getPortfolioChartPartialList.fulfilled]: (state, { payload }) => {
      state.portfolioChartPartialList = payload?.data;
    },
  },
});

export default investmentSlice.reducer;
